import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@progress/kendo-theme-default/dist/all.css";
import "./styles/theme.css";
import "./styles/mobile.css";
import App from "./App";

const root = document.getElementById("root");
if (!root) throw new Error("Root element not found");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
